












































































import { Component, Vue, Watch } from "vue-property-decorator";
import { TicketUser } from "@/models/ticket_user";
import TicketBuyedTipComponent from "@/components/TicketBuyedTipComponent.vue";
import SystemConst from "@/config/const";
import firebase from "firebase/app";
import "firebase/firestore";
import PurchasedTicketService from "@/services/PurchasedTicketService";
const db = firebase.firestore();

@Component({
  name: "TicketBuyedApp",
  components: {
    TicketBuyedTipComponent,
  },
})
export default class TicketBuyedApp extends Vue {
  selectedTicketType = SystemConst.TICKET_TYPE_ALL;
  ticketType = SystemConst.TICKET_TYPE;
  selectedTicketStatus = SystemConst.PURCHASED_TICKET_STATUS_UNUSE;
  systemConst = SystemConst;
  page = 1;
  perPage = 10;
  purchased_tickets = [];
  readMore = false;
  isLoadingMore = false;
  isProcessing = false;

  getMenu(selectMenu: any): boolean {
    return this.selectedTicketStatus === selectMenu;
  }
  setMenu(selectMenu: any) {
    this.selectedTicketStatus = selectMenu;
  }

  async fetchPurchasedTicket(changeType = false) {
    if (this.isProcessing) return;
    this.isProcessing = true;
    const query = {
      page: this.page,
      per_page: this.perPage,
      ticket_type: this.selectedTicketType,
      status: this.selectedTicketStatus,
    };
    const {
      data: { purchased_tickets, read_more },
    } = await PurchasedTicketService.getPurchasedTickets(query);
    this.readMore = read_more;
    if (changeType) {
      this.purchased_tickets = purchased_tickets;
    } else {
      this.purchased_tickets = this.purchased_tickets.concat(purchased_tickets);
    }
    this.isProcessing = false;
  }

  async getMore() {
    if (this.isLoadingMore) return;
    this.isLoadingMore = true;
    this.page += 1;
    await this.fetchPurchasedTicket();
    this.isLoadingMore = false;
  }

  public async created() {
    await this.fetchPurchasedTicket();
  }

  public mounted() {
    document.title =
      "購入したサービス一覧 | favsalon(ファブサロン) | 再来率を向上させるサロンに特化したネットショップサービス";
    const descriptonMeta = document.querySelector("meta[name='description']");
    if (descriptonMeta) {
      descriptonMeta.setAttribute(
        "content",
        "購入したサービス一覧 | favsalon（ファブサロン）なら美容室やネイルサロン、リラクサロンなどのサロンメニューに特化したネットサロンを簡単に作ることができます。シークレットメニューで来店者のみに販売するサービスを作って再来率を向上させます！"
      );
    }
    const robotsMeta = document.querySelector("meta[name='robots']");
    if (robotsMeta) {
      robotsMeta.setAttribute("content", "noindex");
    }
  }

  @Watch("selectedTicketType", { deep: true })
  onSelectedTicketTypeChanged() {
    this.page = 1;
    this.fetchPurchasedTicket(true);
  }

  @Watch("selectedTicketStatus", { deep: true })
  onSelectedTicketStatus() {
    this.page = 1;
    this.fetchPurchasedTicket(true);
  }
}
